module.exports = __webpack_public_path__ + "media/crossfade.e8de9922.mp3";